const MessagesTab = ({ contactMessages, onUpdateStatus, onDelete, onReply }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4">KONTAKTINDBAKKE</h2>
      {contactMessages.length === 0 ? (
        <p className="text-gray-500 text-center py-8">Ingen beskeder endnu</p>
      ) : (
        contactMessages.map((msg) => (
          <div key={msg.message_id} className={`mc-card p-6 border-l-4 ${msg.status === "new" ? "border-l-red-500" : msg.status === "in_progress" ? "border-l-yellow-500" : "border-l-green-500"}`}>
            <div className="flex flex-col lg:flex-row justify-between items-start gap-4">
              <div className="flex-1 space-y-3">
                <div><h3 className="text-white font-bold text-lg">{msg.subject}</h3><p className="text-gray-300">Fra: {msg.name} ({msg.email})</p></div>
                <div className="bg-black/30 rounded-lg p-4 border border-white/10"><p className="text-gray-200 whitespace-pre-wrap">{msg.message}</p></div>
                {msg.admin_reply && <div className="bg-green-900/20 rounded-lg p-4 border border-green-500/30"><p className="text-gray-200 whitespace-pre-wrap">{msg.admin_reply}</p></div>}
              </div>
              <div className="flex flex-col gap-2 min-w-[150px]">
                {msg.status !== "answered" && (
                  <>
                    <select value={msg.status} onChange={(e) => onUpdateStatus(msg.message_id, e.target.value)} className="mc-input py-2 px-3 text-sm">
                      <option value="new">Ny</option>
                      <option value="in_progress">Under behandling</option>
                      <option value="answered">Besvaret</option>
                    </select>
                    <button onClick={() => onReply(msg)} className="chrome-btn px-4 py-2 rounded-lg text-sm">Svar</button>
                  </>
                )}
                <button onClick={() => onDelete(msg.message_id)} className="text-red-400 hover:text-red-300 px-4 py-2 text-sm">Slet</button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default MessagesTab;
